import { render, staticRenderFns } from "./ProjectService.vue?vue&type=template&id=3ace8591&scoped=true&"
import script from "./ProjectService.vue?vue&type=script&lang=js&"
export * from "./ProjectService.vue?vue&type=script&lang=js&"
import style0 from "./ProjectService.vue?vue&type=style&index=0&id=3ace8591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace8591",
  null
  
)

export default component.exports